import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { Typography } from "@vc-workspace/utils-typography";
import { containerStyles, contentGridContainer, contentGridItemContainer, contentGridItemImage, contentGridItemContent } from './maker-vibecity-tools.module.style';
export function MakerVibecityTools(props) {
  return _jsxs("div", {
    css: containerStyles,
    children: [_jsxs(Typography, {
      type: props.context.isMobileView ? "Headline_H1" : "Heading2",
      color: "night_rider",
      className: "text-center",
      bold: true,
      children: ["Vibecity comes with simple yet powerful tools to", !props.context.isMobileView ? _jsx("br", {}) : null, " manage & grow your business"]
    }), _jsx("div", {
      className: !props.context.isMobileView ? "page-container" : "",
      children: _jsxs("div", {
        css: contentGridContainer,
        children: [_jsxs("div", {
          css: contentGridItemContainer,
          children: [props.context.isMobileView ? _jsxs("div", {
            css: contentGridItemContent,
            children: [_jsx(Typography, {
              type: "Headline_H1",
              color: "night_rider",
              semi_bold: true,
              children: "Your Customisable Online Shop"
            }), _jsx(Typography, {
              type: "Body1",
              color: "night_rider",
              className: "pt-2",
              children: "Create your own branded online shop. Share to your customers on social media"
            })]
          }) : null, _jsxs("picture", {
            children: [_jsx("source", {
              srcSet: "/_mp-images/customise_shop_new.webp",
              type: "image/webp"
            }), _jsx("img", {
              src: "/_mp-images/customise_shop_new.png",
              css: contentGridItemImage
            })]
          }), !props.context.isMobileView ? _jsxs("div", {
            css: contentGridItemContent,
            children: [_jsx(Typography, {
              type: "Headline_H1",
              color: "night_rider",
              semi_bold: true,
              children: "Your Customisable Online Shop"
            }), _jsx(Typography, {
              type: "Body1",
              color: "night_rider",
              className: "pt-2",
              children: "Create your own branded online shop. Share to your customers on social media"
            })]
          }) : null]
        }), _jsxs("div", {
          css: contentGridItemContainer,
          children: [props.context.isMobileView ? _jsxs("div", {
            css: contentGridItemContent,
            children: [_jsx(Typography, {
              type: "Headline_H1",
              color: "night_rider",
              semi_bold: true,
              children: "Easy, Reliable & Intelligent Shipping"
            }), _jsx(Typography, {
              type: "Body1",
              color: "night_rider",
              className: "pt-2",
              children: "Get orders picked from your door by the best courier partners"
            })]
          }) : null, _jsxs("picture", {
            children: [_jsx("source", {
              srcSet: "/_mp-images/order_shipping.webp",
              type: "image/webp"
            }), _jsx("img", {
              src: "/_mp-images/order_shipping.png",
              css: contentGridItemImage
            })]
          }), !props.context.isMobileView ? _jsxs("div", {
            css: contentGridItemContent,
            children: [_jsx(Typography, {
              type: "Headline_H1",
              color: "night_rider",
              semi_bold: true,
              children: "Easy, Reliable & Intelligent Shipping"
            }), _jsx(Typography, {
              type: "Body1",
              color: "night_rider",
              className: "pt-2",
              children: "Get orders picked from your door by the best courier partners"
            })]
          }) : null]
        }), _jsxs("div", {
          css: contentGridItemContainer,
          children: [props.context.isMobileView ? _jsxs("div", {
            css: contentGridItemContent,
            children: [_jsx(Typography, {
              type: "Headline_H1",
              color: "night_rider",
              semi_bold: true,
              children: "Simplified & Timely Payments"
            }), _jsx(Typography, {
              type: "Body1",
              color: "night_rider",
              className: "pt-2",
              children: "You control how you get paid, daily payout straight to your bank account"
            })]
          }) : null, _jsxs("picture", {
            children: [_jsx("source", {
              srcSet: "/_mp-images/earnings.webp",
              type: "image/webp"
            }), _jsx("img", {
              src: "/_mp-images/earnings.png",
              css: contentGridItemImage
            })]
          }), !props.context.isMobileView ? _jsxs("div", {
            css: contentGridItemContent,
            children: [_jsx(Typography, {
              type: "Headline_H1",
              color: "night_rider",
              semi_bold: true,
              children: "Simplified & Timely Payments"
            }), _jsx(Typography, {
              type: "Body1",
              color: "night_rider",
              className: "pt-2",
              children: "You control how you get paid, daily payout straight to your bank account"
            })]
          }) : null]
        }), _jsxs("div", {
          css: contentGridItemContainer,
          children: [props.context.isMobileView ? _jsxs("div", {
            css: contentGridItemContent,
            children: [_jsx(Typography, {
              type: "Headline_H1",
              color: "night_rider",
              semi_bold: true,
              children: "Hassle free Order Management"
            }), _jsx(Typography, {
              type: "Body1",
              color: "night_rider",
              className: "pt-2",
              children: "Manage & Track your orders, notify your customers. All from one place!"
            })]
          }) : null, _jsxs("picture", {
            children: [_jsx("source", {
              srcSet: "/_mp-images/my_orders.webp",
              type: "image/webp"
            }), _jsx("img", {
              src: "/_mp-images/my_orders.png",
              css: contentGridItemImage
            })]
          }), !props.context.isMobileView ? _jsxs("div", {
            css: contentGridItemContent,
            children: [_jsx(Typography, {
              type: "Headline_H1",
              color: "night_rider",
              semi_bold: true,
              children: "Hassle free Order Management"
            }), _jsx(Typography, {
              type: "Body1",
              color: "night_rider",
              className: "pt-2",
              children: "Manage & Track your orders, notify your customers. All from one place!"
            })]
          }) : null]
        })]
      })
    })]
  });
}
export default MakerVibecityTools;